import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bdf8bda&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdf8bda')) {
      api.createRecord('4bdf8bda', component.options)
    } else {
      api.reload('4bdf8bda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4bdf8bda&", function () {
      api.rerender('4bdf8bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/swimming/order/index.vue"
export default component.exports